import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Hero from './components/Hero';
import ProblemSection from './components/ProblemSection';
import SolutionModules from './components/SolutionModules';
import DashboardPreview from './components/DashboardPreview';
import FeatureGrid from './components/FeatureGrid';
import PricingSection from './components/PricingSection';
import Testimonials from './components/Testimonials';
import CTASection from './components/CTASection';
import Footer from '../../components/feature/Footer';
import SEO from '../../components/feature/SEO';

export default function HomePage() {
  const { t } = useTranslation();
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const windowHeight = document.documentElement.scrollHeight - window.innerHeight;
      const progress = (window.scrollY / windowHeight) * 100;
      setScrollProgress(Math.min(progress, 100));
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    // Add Schema.org JSON-LD
    const schemaScript = document.createElement('script');
    schemaScript.type = 'application/ld+json';
    schemaScript.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      "name": "reputrust.ai",
      "applicationCategory": "BusinessApplication",
      "operatingSystem": "Web",
      "url": "https://reputrust.ai",
      "description": t('seo.description.home'),
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "EUR",
        "priceValidUntil": "2025-12-31",
        "availability": "https://schema.org/InStock"
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.9",
        "ratingCount": "500"
      },
      "provider": {
        "@type": "Organization",
        "name": "SMC Simon Müller Consulting e.K.",
        "url": "https://reputrust.ai"
      }
    });
    document.head.appendChild(schemaScript);

    return () => {
      if (schemaScript.parentNode) {
        schemaScript.parentNode.removeChild(schemaScript);
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <SEO />
      <Header />

      {/* Enhanced Progress Bar */}
      <div className="fixed top-0 left-0 right-0 h-1 bg-gray-100 z-50">
        <div
          className="h-full bg-gradient-to-r from-[#1E3A8A] via-[#10B981] to-[#1E3A8A] transition-all duration-300 shadow-lg shadow-[#10B981]/20"
          style={{ width: `${scrollProgress}%` }}
        ></div>
      </div>

      <Hero />
      <ProblemSection />
      <SolutionModules />
      <DashboardPreview />
      <FeatureGrid />
      <PricingSection />
      <Testimonials />
      <CTASection />
      <Footer />
    </div>
  );
}
